export default "__VITE_ASSET__DA5GaHvQ__"